import { Header } from "components/Header";
import Footer from "components/Footer/Footer";
import { Container } from "layouts/Container/Container";
import { Outlet } from "react-router-dom";
import avatarImage from "../../icons/avatar.png";
import { useState } from "react";

export function Layout() {
  const [avatar, setAvatar] = useState<string>(avatarImage);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setAvatar(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Header />
      <main style={{ background: "#F9F3F9" }}>
        <Container>
          <Outlet context={{ avatar, handleFileChange }} />
        </Container>
      </main>
      <Footer />
    </>
  );
}
